<template>
  <div>
    <div v-if="cart.itemTableLoading">
      <loading-component
        class="hidden-lg hidden-md hidden-sm"
      ></loading-component>
    </div>
    <div
      v-for="cartItem in cart.cartItems"
      v-else
      :key="cartItem.itemId"
      class="cart-items-container row hidden-lg hidden-md hidden-sm"
    >
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="panel-title">
            <span class="media">
              <div>
                <a :href="'/shop/' + cartItem.name">
                  <img
                    class="cart-item-image"
                    :src="cartItem.imagePath"
                    :alt="cartItem.label"
                  />
                </a>
              </div>
              <div class="media-body">
                <div class="product-name">
                  <p>{{ cartItem.label }}</p>
                  <hr />
                  <p v-html="cartItem.description"></p>
                </div>
              </div>
            </span>
          </div>
        </div>
        <div class="panel-body">
          ${{ cartItem.totalProductPrice }}
          <small v-if="cartItem.period" :v-html="cartItem.periodCartText">
          </small>
          <div v-if="cartItem.totalAddonPrice > 0">
            <hr />
            <small>+ ${{ cartItem.totalAddonPrice }}</small>
            <small>
              <a
                href="javascript:void(0)"
                data-toggle="tooltip"
                data-placement="top"
                :title="cartItem.addonDescription"
              >
                {{ cartItem.addonName }}
                <i class="fa fa-info-circle"></i>
              </a>
            </small>
          </div>
        </div>
        <div class="panel-footer">
          <span class="col-xs-12 col-sm-4">
            <mobile-item-quantity
              :quantity="cartItem.quantity"
              :item-id="cartItem.itemId"
              :item-label="cartItem.label"
            ></mobile-item-quantity>
          </span>
          <span class="col-xs-12 col-sm-6">
            <span>
              Subtotal: ${{ cartItem.subTotal }}
              <small>{{ cart.currency }}</small>
            </span>
          </span>
          <span class="clearfix"></span>
        </div>
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "../../store/stores";
import MobileItemQuantity from "./MobileItemQuantity.vue";
import LoadingComponent from "../checkout/components/elements/LoadingComponent.vue";

export default {
  name: "MobileItemPanelRow",
  components: { MobileItemQuantity, LoadingComponent },
  store,
  computed: {
    ...mapState(["cart"]),
  },
  methods: {
    deleteItem(event, itemId) {
      this.$store.dispatch("cart/deleteCartItem", itemId);
    },
    updateCartItem(event, itemId) {
      const quantity = event.target.value;
      this.$store.dispatch("cart/updateCartItemQuantity", {
        itemId,
        quantity,
      });
    },
  },
};
</script>

<style scoped>
.cart-items-container {
  padding-top: 25px;
}

.cart-item-image {
  width: 80%;
}
</style>
